import { render, staticRenderFns } from "./BannerDialog.vue?vue&type=template&id=204c6aef"
import script from "./BannerDialog.vue?vue&type=script&lang=js"
export * from "./BannerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports